export const CREATE_PROJECT_CHILD_COMMENT_ATTEMPT = 'CREATE_PROJECT_CHILD_COMMENT_ATTEMPT';
export type CREATE_PROJECT_CHILD_COMMENT_ATTEMPT = typeof CREATE_PROJECT_CHILD_COMMENT_ATTEMPT;

export const CREATE_PROJECT_CHILD_COMMENT_SUCCESS = 'CREATE_PROJECT_CHILD_COMMENT_SUCCESS';
export type CREATE_PROJECT_CHILD_COMMENT_SUCCESS = typeof CREATE_PROJECT_CHILD_COMMENT_SUCCESS;

export const CREATE_PROJECT_CHILD_COMMENT_FAILURE = 'CREATE_PROJECT_CHILD_COMMENT_FAILURE';
export type CREATE_PROJECT_CHILD_COMMENT_FAILURE = typeof CREATE_PROJECT_CHILD_COMMENT_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/comments/create-child-comment/Types.tsx